import { Component, type ErrorInfo, type ReactNode } from "react";
import { logger } from "../lib/logger.ts";
import { ErrorState } from "../components/ErrorState.tsx";

interface Props {
  children: ReactNode;
}
interface State {
  hasError: boolean;
}

/** Top-level boundary: render errors are logged (no PII) and replaced with a safe UI. */
export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    logger.error("ui_crash", {
      message: error.message,
      componentStack: info.componentStack?.slice(0, 500),
    });
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        <ErrorState
          title="Something went wrong"
          message="Please refresh the page to try again."
        />
      );
    }
    return this.props.children;
  }
}
